import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import axios from "axios";
import './admin/assets/vendor/bootstrap/css/bootstrap.min.css';
import './admin/assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './admin/assets/vendor/boxicons/css/boxicons.min.css';
import './admin/assets/vendor/quill/quill.snow.css';
import './admin/assets/vendor/quill/quill.bubble.css';
import './admin/assets/vendor/remixicon/remixicon.css';
import './admin/assets/vendor/simple-datatables/style.css';
import './admin/assets/css/style.css';
import reportWebVitals from './reportWebVitals';
// import AppRoutes from './routes/Routes';


import Login from './admin/auth/Login';
import Dashboard from './admin/dashboard/Dashboard';
import Customers from './admin/customers/Customers';
import ViewCustomer from './admin/customers/ViewCustomer';
import Wallets from './admin/cryptowallet/Wallets';
import Cards from './admin/cards/Cards';
import ViewCard from './admin/cards/ViewCard';
import ViewWallet from './admin/cryptowallet/ViewWallet';
import Deposits from './admin/deposits/Deposits';
import Withdrawals from './admin/withdrawals/withdrawals';
import LandingPage from './user/landing/landing';
import AboutPage from './user/landing/about';
import ContactPage from './user/landing/contact';
import Transactions from './admin/transactions/Transactions';

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/customers",
    element: <Customers />,
  },
  {
    path: "/customer",
    element: <ViewCustomer />,
  },
  {
    path: "/virtual-cards",
    element: <Cards />,
  },
  {
    path: "/card",
    element: <ViewCard />,
  },
  {
    path: "/crypto-wallets",
    element: <Wallets />,
  },
  {
    path: "/wallet",
    element: <ViewWallet />,
  },
  {
    path: "/deposits",
    element: <Deposits />,
  },
  {
    path: "/withdrawals",
    element: <Withdrawals />,
  },
  {
    path: "/transactions",
    element: <Transactions />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    {/* <RouterProvider router={router} /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
